import axios from "./axiosInstance";
import { server } from "../config";

const compileProject = async (projectId) => {
  const res = await axios.post(`${server}/api/project/compile/`, {
    id: projectId,
    project_id: projectId,
  });
  return res.data?.data;
};

export { compileProject };
